import {
    CLEAR_TIMER,
    SET_TIMER_CUSTOM_APP_ID,
    SET_TIMER_USER_ID,
    SET_CURRENT_SESSION,
    SET_TIMER_RUNNING,
    SET_TOTAL_TIME,
    UPDATE,
    SET_AND_START_TIMER,
    REQUEST_FAILED,
  } from "../actions/userActivity";
  
  import { LOG_OUT } from "../actions/user";
  
  const defaultState = {
    userId: null,
    customAppId: null,
    currentSession: 0,
    totalTime: 0,
    shouldTrackTimeInChart: false,
    timerRunning: false,
    isError: false,
    errMsg: null,
  };
  
  export default (state = defaultState, action) => {
    switch (action.type) {
      case CLEAR_TIMER:
        return {
          userId: null,
          customAppId: null,
          currentSession: 0,
          totalTime: 0,
          timerRunning: false,
          shouldTrackTimeInChart: false,
          isError: false,
          errMsg: null,
        };
      case SET_TIMER_RUNNING:
        return Object.assign({}, state, {
          timerRunning: action.timerRunning,
        });
      case SET_CURRENT_SESSION:
        return Object.assign({}, state, {
          currentSession: action.currentSession,
        });
      case SET_TOTAL_TIME:
        return Object.assign({}, state, {
          totalTime: action.totalTime,
        });
      case UPDATE:
        //Only apply timer interval update when timer is still running
        if (state.timerRunning) {
          const newTotalTime = state.totalTime + action.deltaTime;
          const newCurrentSessionTime = state.currentSession + action.deltaTime;
          return Object.assign({}, state, {
            currentSession: newCurrentSessionTime,
            totalTime: newTotalTime,
          });
        } else {
          return state;
        }
      case SET_TIMER_CUSTOM_APP_ID:
        return Object.assign({}, state, {
          customAppId: action.customAppId,
        });
      case SET_TIMER_USER_ID:
        return Object.assign({}, state, {
          userId: action.userId,
        });
      case SET_AND_START_TIMER:
        return Object.assign({}, state, {
          userId: action.userId,
          customAppId: action.customAppId,
          timerRunning: true,
          totalTime: action.totalTime,
          currentSession: 0,
          shouldTrackTimeInChart: action.shouldTrackTimeInChart,
        });
      case REQUEST_FAILED:
        return Object.assign({}, state, {
          isError: true,
          errMsg: action.message,
        });
      case LOG_OUT:
        return {
          userId: null,
          customAppId: null,
          currentSession: 0,
          totalTime: 0,
          timerRunning: false,
          shouldTrackTimeInChart: false,
          isError: false,
          errMsg: null,
        };
      default:
        return state;
    }
  };
  


// WEBPACK FOOTER //
// ./src/reducers/userActivity.js